import { initializeVersionSelects } from "#/admin/legacy/versions/version-selects.js";
import "#lib/assert.js";

jQuery(function () {
  if (!document.getElementById("version_preview_containers")) {
    return;
  }

  var iframes = new Asserter().element("#version_preview_containers .preview iframe");
  var respondToScroll = true; // A lock that prevents scrolling feedback between the two panes

  iframes.each(function (i) {
    var $thisWindow = jQuery(this.contentWindow);
    var $otherWindow = jQuery(iframes.not(this)[0].contentWindow);

    // Link scrolling
    $thisWindow.on("scroll", function () {
      if (respondToScroll) {
        respondToScroll = false;
        $otherWindow.scrollTop($thisWindow.scrollTop());
      } else {
        respondToScroll = true;
      }
    });
  });

  // Disable interaction with the version
  iframes.on("load", function () {
    jQuery(this.contentDocument.body)
      .css("pointer-events", "none")
      .on("keydown", function (event) {
        if (!event.metaKey) {
          return false;
        }
      });
  });

  initializeVersionSelects(document);

  // Toggle view modes
  var buttons = jQuery("[data-behaviour=show-version]");

  buttons.on("click", function () {
    buttons.removeClass("selected");
    jQuery(this).addClass("selected");

    var version = jQuery(this).data("version");

    if (version.match(/A/i)) {
      jQuery("[data-behaviour=version-a]").show();
    } else {
      jQuery("[data-behaviour=version-a]").hide();
    }

    if (version.match(/B/i)) {
      jQuery("[data-behaviour=version-b]").show();
    } else {
      jQuery("[data-behaviour=version-b]").hide();
    }

    jQuery(this).blur();
  });

  buttons.first().trigger("click");

  // Toggle Sidebar
  var sidebarButton = jQuery("[data-behaviour=toggle-sidebar]");
  sidebarButton.addClass("selected");

  sidebarButton.on("click", function () {
    sidebarButton.toggleClass("selected");
    jQuery("[data-behaviour=version-change-history]").toggle(sidebarButton.hasClass("selected"));
    sidebarButton.blur();
  });
});
